import { QuickFactsAndQuestions } from '../types/quickFacts'
import { currencySymbol } from './price'

const transformQuickFactsAndQuestions = ({
  quickFactsRaw = {},
  topQuestionsRaw = [],
  profileType,
  profileSearchType,
  language
}: {
  quickFactsRaw: { [key: string]: any }
  topQuestionsRaw: Array<{ [key: string]: any }>
  profileType: string
  profileSearchType: string
  language: string
}): QuickFactsAndQuestions => {
  return {
    ...quickFactsRaw,
    fees: {
      new: quickFactsRaw.fees?.new ? String(quickFactsRaw.fees.new) : '',
      follow: quickFactsRaw.fees?.follow ? String(quickFactsRaw.fees.follow) : '',
      currency: currencySymbol(quickFactsRaw.fees?.currency, language) || null
    },
    topRated: {
      ...(quickFactsRaw.topRated ?? {}),
      name: quickFactsRaw.topRated?.name || quickFactsRaw.topRated?.fullName || {}
    },
    topReviewed: {
      ...(quickFactsRaw.topReviewed ?? {}),
      name: quickFactsRaw.topReviewed?.name || quickFactsRaw.topReviewed?.fullName || {}
    },
    topEndorsed: {
      ...(quickFactsRaw.topEndorsed ?? {}),
      name: quickFactsRaw.topEndorsed?.name || quickFactsRaw.topEndorsed?.fullName || {}
    },
    questions: topQuestionsRaw.map((q) => ({ question: q.question || '', answer: q.answer || '' })),
    profileType,
    profileSearchType
  } as QuickFactsAndQuestions
}

export default transformQuickFactsAndQuestions
